import { superCall as _$su, className as _$cn, extend as _$ex, EMPTY_OBJ as _$em, createElementVNode as _$ce, createUnknownComponentVNode as _$cc } from 'intact-vue-next';
import { Icon } from '../icon';
import { Button } from '../button';
import { makeAlertStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    type = _this$get.type,
    content = _this$get.content,
    hideIcon = _this$get.hideIcon,
    hideFooter = _this$get.hideFooter,
    hideClose = _this$get.hideClose,
    title = _this$get.title,
    iconClassName = _this$get.iconClassName,
    icon = _this$get.icon;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-alert-dialog"] = true, _classNameObj[k + "-" + type] = true, _classNameObj[k + "-with-title"] = title, _classNameObj[makeAlertStyles(k)] = true, _classNameObj);
  return _$su.call($this, {
    'className': _$cn(classNameObj)
  }, function ($blocks) {
    var _$blocks = {},
      __$blocks = _$ex({}, $blocks);
    return (_$blocks['header'] = function ($super) {
      return null;
    }, __$blocks['header'] = function ($super, data) {
      var block = $blocks['header'];
      var callBlock = function callBlock() {
        return _$blocks['header'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }), (_$blocks['body'] = function ($super) {
      var _ref;
      return [_$ce(2, 'div', [!hideIcon && !icon ? _$cc(Icon, {
        'className': _$cn(iconClassName || (_ref = {}, _ref[k + "-icon-success-fill"] = type === 'success', _ref[k + "-icon-warning-fill"] = type === 'warning' || type === 'confirm', _ref[k + "-icon-error-fill"] = type === 'error', _ref)),
        'color': type === 'error' ? 'danger' : type === 'confirm' ? 'warning' : type
      }) : undefined, icon], 0, _$cn(k + "-dialog-tip-icon")), _$ce(2, 'div', [title ? _$ce(2, 'div', title, 0, _$cn(k + "-alert-dialog-title")) : undefined, content], 0, _$cn(k + "-alert-dialog-wrapper"))];
    }, __$blocks['body'] = function ($super, data) {
      var block = $blocks['body'];
      var callBlock = function callBlock() {
        return _$blocks['body'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }), (_$blocks['footer'] = function ($super) {
      return hideFooter ? null : $super();
    }, __$blocks['footer'] = function ($super, data) {
      var block = $blocks['footer'];
      var callBlock = function callBlock() {
        return _$blocks['footer'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }), __$blocks;
  }.call($this, $blocks), $__proto__);
}
;